import React from "react";
import "./Footer.css";
import insta from "../assets/instagram.png";
import fb from "../assets/facebook.png";
import twitter from "../assets/Twitter.png";
import linkedin from "../assets/linkedin.png";
import WhatsappFloat from "../whatsapp/Whatsapp";

export default function Footer() {

  const currentyear = new Date().getFullYear();

  return (
    <div className="footer wrapper" style={{display:"flex",justifyContent:"center", alignItems:"center",textAlign:"center"}}>
      <span >© {currentyear} BusinessBay.io | Powered by BusinessBay.io</span>
      {/* <div className="logos">
        <a
          href="https://www.facebook.com/profile.php?id=61551454974033"
          target="_blank"
        >
          <img src={fb} alt="error" />
        </a>
        <a
          href="https://www.facebook.com/profile.php?id=61551454974033"
          target="_blank"
        >
          {" "}
          <img src={twitter} alt="error" />
        </a>
        <a
          href="https://www.facebook.com/profile.php?id=61551454974033"
          target="_blank"
        >
          <img src={linkedin} alt="error" />
        </a>
        <a
          href="https://www.facebook.com/profile.php?id=61551454974033"
          target="_blank"
        >
          <img src={insta} alt="error" />
        </a>
      </div> */}
      <WhatsappFloat/>
    </div>
  );
}
